import Compressor from 'compressorjs';

const MAX_FILE_SIZE = 1024 * 1024 * 5; // 5MB
const QUALITY_STEPS = [0.8, 0.6, 0.45, 0.3];

const compressOnce = (file, quality) =>
    new Promise((resolve, reject) => {
        new Compressor(file, {
            quality,
            mimeType: 'image/webp',
            maxWidth: 1800,
            maxHeight: 1800,
            success(result) {
                resolve(result);
            },
            error(err) {
                reject(err);
            },
        });
    });

const compressToTargetSize = async (file, [quality, ...remainingQualities]) => {
    const compressedFile = await compressOnce(file, quality);

    if (compressedFile.size <= MAX_FILE_SIZE || remainingQualities.length === 0) {
        return compressedFile;
    }
    return await compressToTargetSize(file, remainingQualities);
};

export const compressImage = async (file) => {
    try {
        if (!file?.type?.startsWith('image/')) {
            return file;
        }
        return await compressToTargetSize(file, QUALITY_STEPS);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(`Error compressing image: ${err.message}`);
        return file;
    }
};
